/* Rollin'Denims · back-in-stock + size request capture (PDP) v1
   Sold-out size  -> "Notify me" form. Size not listed -> request form.
   Each request: (1) Shopify customer, tagged notify-me + bis-<SKU>  (drives the restock email via Flow)
                 (2) email to the team with every detail             (Shopify contact form -> admin@)
                 (3) confirmation to the rider, when EmailJS is set  (window.RD_MAIL)
                 (4) Lead event for Meta / Google / Shopify pixels                                     */
(function () {
  'use strict';
  var ready = function (fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (m) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); };
  var KEY = 'rd_nm_v1';
  var mine = function () { try { return JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { return {}; } };
  var remember = function (k, v) { try { var m = mine(); m[k] = v; localStorage.setItem(KEY, JSON.stringify(m)); } catch (e) {} };
  var BELL = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="square" aria-hidden="true"><path d="M6 16V10a6 6 0 0 1 12 0v6l2 2H4z"/><path d="M10 21h4"/></svg>';

  /* in-stock sizes of the other riding jeans, rendered by Liquid into #rd-alt-data */
  var ALT = null;
  window.rdCut = function (h) { h = String(h || '').toLowerCase(); return /relaxed/.test(h) ? 'relaxed fit' : /slim|taper/.test(h) ? 'slim tapered fit' : /snug|performance/.test(h) ? 'snug performance fit' : ''; };
  window.rdAlts = function (size, armour) {
    if (ALT === null) { try { ALT = JSON.parse((document.getElementById('rd-alt-data') || {}).textContent || '[]'); } catch (e) { ALT = []; } }
    var out = [];
    ALT.forEach(function (p) {
      var hit = null, any = null;
      p.v.forEach(function (x) { if (String(x[0]) === String(size)) { if (!any) any = x; if (x[1] === armour && !hit) hit = x; } });
      var m = hit || any;
      if (m) out.push({ t: p.t, c: p.c, cut: window.rdCut(p.cut), img: p.img, url: p.u + '?variant=' + m[2], price: '₹' + (m[3] / 100).toLocaleString('en-IN') });
    });
    return out;
  };

  ready(function () {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var wrap = form.closest('[data-callbackvariant]') || form.parentNode;
    var sel = form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]');
    var variants = [];
    try { var vj = (wrap && wrap.querySelector('.pr_variants_json')) || document.querySelector('.pr_variants_json'); if (vj) variants = JSON.parse(vj.textContent); } catch (e) {}
    if (!variants.length) return;
    var cfg = {};
    try { var c = document.getElementById('rd-pdp-config'); if (c) cfg = JSON.parse(c.textContent); } catch (e) {}
    var title = (cfg.jeansName || cfg.title || document.title).trim();
    var wa = cfg.whatsapp || '918169097713';
    var handle = (location.pathname.split('/products/')[1] || '').split(/[/?#]/)[0];

    var curVar = function () {
      var id = sel ? String(sel.value) : '';
      for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) return variants[i];
      return variants[0];
    };
    var allOut = variants.every(function (v) { return !v.available; });

    /* ---- panel ---- */
    var box = document.createElement('div');
    box.className = 'rd-nm'; box.hidden = true; box.id = 'rd-nm';
    box.innerHTML =
      '<div class="rd-nm__head">' + BELL + '<div><p class="rd-nm__t" data-nm-title></p><p class="rd-nm__s" data-nm-sub></p></div></div>' +
      '<div class="rd-nm__alt" data-nm-alt hidden></div>' +
      '<form class="rd-nm__form" novalidate>' +
        '<div class="rd-nm__row" data-nm-sizerow hidden><label for="rd-nm-size">Size you need</label><input id="rd-nm-size" name="size" type="text" inputmode="numeric" maxlength="12" placeholder="e.g. 46, or waist 29"></div>' +
        '<div class="rd-nm__grid">' +
          '<div class="rd-nm__row"><label for="rd-nm-name">Name</label><input id="rd-nm-name" name="rname" type="text" autocomplete="given-name" required></div>' +
          '<div class="rd-nm__row"><label for="rd-nm-email">Email</label><input id="rd-nm-email" name="email" type="email" autocomplete="email" required></div>' +
          '<div class="rd-nm__row"><label for="rd-nm-wa">WhatsApp <span>optional</span></label><input id="rd-nm-wa" name="wa" type="tel" inputmode="tel" autocomplete="tel" placeholder="10-digit mobile"></div>' +
          '<div class="rd-nm__row"><label for="rd-nm-when">Need it by</label><select id="rd-nm-when" name="when"><option>This week</option><option>This month</option><option>No rush</option></select></div>' +
        '</div>' +
        '<p class="rd-nm__err" data-nm-err hidden></p>' +
        '<button type="submit" class="rd-nm__btn">Notify me</button>' +
        '<p class="rd-nm__fine" data-nm-fine></p>' +
      '</form>' +
      '<div class="rd-nm__ok" data-nm-ok hidden></div>';

    var btns = form.querySelector('.t4s-product-form__buttons');
    if (btns) btns.parentNode.insertBefore(box, btns); else form.appendChild(box);

    var f = box.querySelector('form'), tEl = box.querySelector('[data-nm-title]'), sEl = box.querySelector('[data-nm-sub]');
    var okEl = box.querySelector('[data-nm-ok]'), errEl = box.querySelector('[data-nm-err]'), sizeRow = box.querySelector('[data-nm-sizerow]');
    var mode = 'bis', target = null, fine = box.querySelector('[data-nm-fine]');
    var FINE = { bis: 'One email when it\'s back, and the occasional new drop. Unsubscribe any time.', req: 'We only email you about this size, and the occasional new drop. Unsubscribe any time.' };

    // prefill from anything the rider already typed on this device
    try { var p = JSON.parse(localStorage.getItem('rd_nm_me') || 'null'); if (p) { f.rname.value = p.n || ''; f.email.value = p.e || ''; f.wa.value = p.w || ''; } } catch (e) {}

    var label = function (v) { return v && v.title && v.title !== 'Default Title' ? v.title : ''; };

    /* same size, in stock, in another style */
    var altEl = box.querySelector('[data-nm-alt]');
    var showAlts = function (v) {
      var list = v ? window.rdAlts(v.option1, v.option2) : [];
      altEl.hidden = !list.length;
      if (!list.length) { altEl.innerHTML = ''; return; }
      altEl.innerHTML = '<p class="rd-nm__alth">Size ' + esc(v.option1) + ' is in stock in</p>' + list.slice(0, 3).map(function (a) {
        return '<a class="rd-nm__alti" href="' + esc(a.url) + '">' + (a.img ? '<img src="' + esc(a.img) + '" alt="" width="56" height="70" loading="lazy">' : '') +
          '<span><b>' + esc(a.t) + '</b><small>' + esc([a.c, a.cut].filter(Boolean).join(' · ')) + '</small></span><em>' + esc(a.price) + '</em></a>';
      }).join('');
    };
    var showOk = function (msg) {
      f.hidden = true; okEl.hidden = false;
      okEl.innerHTML = '<p><b>' + msg + '</b></p><p>Need it sooner? <a href="https://wa.me/' + wa + '?text=' + encodeURIComponent('Hi, I\'m waiting for ' + title + (target ? ' ' + label(target) : '') + '. Any update?') + '" target="_blank" rel="noopener">Message us on WhatsApp</a></p>';
    };

    var render = function () {
      if (mode === 'req') return;
      var v = curVar();
      if (!v || v.available) { box.hidden = true; showAlts(null); return; }
      target = v; box.hidden = false; sizeRow.hidden = true; fine.textContent = FINE.bis;
      showAlts(v);
      tEl.textContent = (label(v) || 'This size') + ' is sold out';
      sEl.textContent = 'Leave your details. We email you the moment it\'s back.';
      var done = mine()[v.id];
      if (done) showOk('You\'re on the list for ' + (label(v) || title) + '. We\'ll email ' + esc(done) + '.');
      else { f.hidden = false; okEl.hidden = true; var nb = f.querySelector('button'); nb.disabled = false; nb.textContent = 'Notify me'; }
    };

    var last = null;
    var poke = function () { var id = sel ? sel.value : ''; if (id !== last) { last = id; if (mode !== 'req') render(); } };
    if (sel) sel.addEventListener('change', poke);
    form.addEventListener('click', function () { setTimeout(poke, 80); });
    setInterval(poke, 400);
    render();

    /* ---- "size not listed" ---- */
    var sizeList = null;
    $$('[data-swatch-option]', form).forEach(function (o) {
      var t = o.querySelector('.t4s-swatch__title'); if (t && /size/i.test(t.textContent) && !sizeList) sizeList = o;
    });
    if (sizeList) {
      var a = document.createElement('button');
      a.type = 'button'; a.className = 'rd-nm__ask';
      a.textContent = allOut ? 'Get notified when it\'s back' : 'Size not listed? Request it';
      var after = sizeList.querySelector('.rd-sizehelp') || sizeList.querySelector('.t4s-swatch__list');
      if (after) after.parentNode.insertBefore(a, after.nextSibling);
      a.addEventListener('click', function () {
        mode = allOut ? 'bis' : 'req';
        if (mode === 'req') {
          target = curVar(); box.hidden = false; sizeRow.hidden = false; f.hidden = false; okEl.hidden = true;
          tEl.textContent = 'Request a size'; fine.textContent = FINE.req;
          sEl.textContent = 'Tell us the size you need. We\'ll email you if we make it.';
          var rb = f.querySelector('button'); rb.disabled = false; rb.textContent = 'Send request';
        } else render();
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { (mode === 'req' ? f.size : f.rname).focus({ preventScroll: true }); }, 350);
      });
    }

    /* ---- sticky bar: "Notify me" instead of a dead "Sold out" ---- */
    var sb = document.querySelector('#rd-sticky [data-rd-s-btn]');
    if (sb) {
      var fix = function () {
        var v = curVar();
        if (v && !v.available && sb.textContent !== 'Notify me') { sb.disabled = false; sb.textContent = 'Notify me'; sb.classList.add('is-notify'); }
        if (v && v.available && sb.classList.contains('is-notify')) sb.classList.remove('is-notify');
      };
      new MutationObserver(fix).observe(sb, { attributes: true, childList: true, characterData: true, subtree: true });
      setInterval(fix, 500); fix();
      sb.addEventListener('click', function (e) {
        if (!sb.classList.contains('is-notify')) return;
        e.stopImmediatePropagation(); e.preventDefault();
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { f.rname.focus({ preventScroll: true }); }, 350);
      }, true);
    }

    /* ---- submit ---- */
    var post = function (data) {
      var body = new URLSearchParams();
      Object.keys(data).forEach(function (k) { body.append(k, data[k]); });
      return fetch('/contact', { method: 'POST', body: body, credentials: 'same-origin', headers: { 'Accept': 'text/html' } })
        .then(function (r) { return { ok: r.ok && !/challenge/.test(r.url), url: r.url }; })
        .catch(function () { return { ok: false, url: '' }; });
    };
    var mail = function (params) {
      var c = window.RD_MAIL || {};
      if (!c.key || !c.service || !c.tpl_customer) return Promise.resolve(false);
      return fetch('https://api.emailjs.com/api/v1.0/email/send', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ service_id: c.service, template_id: c.tpl_customer, user_id: c.key, template_params: params })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    };
    var lead = function (info) {
      try { if (window.fbq) window.fbq('track', 'Lead', { content_name: info.product, content_category: info.type }); } catch (e) {}
      try { if (window.gtag) window.gtag('event', 'generate_lead', { item_name: info.product, method: info.type }); } catch (e) {}
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'rd_' + info.type, product: info.product, sku: info.sku }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('rd_' + info.type, info); } catch (e) {}
    };

    f.addEventListener('submit', function (e) {
      e.preventDefault();
      errEl.hidden = true;
      var name = f.rname.value.trim(), email = f.email.value.trim(), w = f.wa.value.replace(/[^\d+]/g, ''), when = f.when.value;
      var size = mode === 'req' ? f.size.value.trim() : '';
      var bad = !name ? 'Enter your name.' : !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email) ? 'Enter a valid email.' :
        (w && w.replace(/\D/g, '').length < 10) ? 'Enter a 10-digit WhatsApp number, or leave it blank.' :
        (mode === 'req' && !size) ? 'Tell us the size you need.' : '';
      if (bad) { errEl.textContent = bad; errEl.hidden = false; return; }
      var b = f.querySelector('button'); b.disabled = true; b.textContent = 'Saving…';
      try { localStorage.setItem('rd_nm_me', JSON.stringify({ n: name, e: email, w: w })); } catch (x) {}

      var v = target || curVar();
      var sku = (v && v.sku) || ('V' + (v && v.id));
      var vlabel = label(v);
      var type = mode === 'req' ? 'size_request' : 'notify_me';
      var sizeTag = size.replace(/[^a-z0-9]+/gi, '').slice(0, 12);
      var tags = mode === 'req'
        ? ['size-request', 'sizereq-' + handle.slice(0, 40) + '-' + sizeTag]
        : ['notify-me', 'bis-' + sku];
      var what = mode === 'req' ? title + ' · size ' + size + (vlabel.indexOf('Armour') > -1 ? ' · ' + vlabel.split('/').pop().trim() : '') : title + ' · ' + vlabel;
      var details = [
        ['Request', mode === 'req' ? 'Size not listed' : 'Back in stock alert'],
        ['Product', what], ['SKU', mode === 'req' ? '-' : sku], ['Name', name], ['Email', email],
        ['WhatsApp', w || '-'], ['Needs it', when], ['Page', location.href.split('#')[0]]
      ];

      var jobs = [
        post({ form_type: 'customer', utf8: '✓', 'contact[email]': email, 'contact[first_name]': name, 'contact[tags]': tags.join(', ') }),
        post({
          form_type: 'contact', utf8: '✓', 'contact[name]': name, 'contact[email]': email, 'contact[phone]': w,
          'contact[Request]': details[0][1], 'contact[Product]': what, 'contact[SKU]': details[2][1], 'contact[Needs it]': when,
          'contact[body]': (mode === 'req' ? 'Size request: ' : 'Notify me when back: ') + what + '\nWhatsApp: ' + (w || '-') + '\nNeeds it: ' + when + '\nPage: ' + details[7][1]
        })
      ];
      Promise.all(jobs).then(function (res) {
        if (!res[0].ok && !res[1].ok) {
          b.disabled = false; b.textContent = mode === 'req' ? 'Send request' : 'Notify me';
          errEl.innerHTML = 'Couldn\'t save that. Try again, or <a href="https://wa.me/' + wa + '?text=' + encodeURIComponent('Notify me when ' + what + ' is back. ' + name + ', ' + email) + '" target="_blank" rel="noopener">send it on WhatsApp</a>.';
          errEl.hidden = false; return;
        }
        if (mode !== 'req' && v) remember(v.id, email);
        lead({ type: type, product: what, sku: sku });
        var rows = details.filter(function (r) { return r[0] !== 'Page' && r[0] !== 'SKU'; });
        mail({
          form_name: mode === 'req' ? 'Size request' : 'Back-in-stock alert',
          reference: sku, to_email: email, to_name: name.split(' ')[0], reply_to: email,
          fields_html: '<table role="presentation" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse">' + rows.map(function (r) { return '<tr><td style="padding:10px 12px;border-bottom:1px solid #e6e6e8;font:600 13px Montserrat,Arial,sans-serif;color:#6f7178;width:38%">' + esc(r[0]) + '</td><td style="padding:10px 12px;border-bottom:1px solid #e6e6e8;font:400 14px Ubuntu,Arial,sans-serif;color:#0d0d0d">' + esc(r[1]) + '</td></tr>'; }).join('') + '</table>',
          fields_text: rows.map(function (r) { return r[0] + ': ' + r[1]; }).join('\n'),
          next_steps: mode === 'req' ? 'We read every size request. If we make it, you hear first.' : 'The moment ' + what + ' is back in stock, we email you a link straight to it.',
          page_url: location.href.split('?')[0], wa_number: '+91 81690 97713', wa_link: 'https://wa.me/918169097713'
        });
        showOk(mode === 'req'
          ? 'Got it. Size ' + esc(size) + ' request saved. We\'ll email ' + esc(email) + '.'
          : 'You\'re on the list for ' + esc(vlabel || title) + '. We\'ll email ' + esc(email) + ' when it\'s back.');
        mode = 'bis';
      });
    });
  });
})();
